module.exports = __webpack_public_path__ + "static/media/wordpress-openlitespeed.8da44093.svg";